module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-144x144-precomposed-dea346ab.png";